import React from "react";
import { ArrowRight } from "lucide-react";
import { useContactModal } from "../context/ContactModalContext";

export default function HomeContactCTA() {
  const { openContactModal } = useContactModal() || {};

  return (
    <section
      id="section-contact-cta"
      className="w-full border-t border-gray-200/80 bg-white py-10 md:py-12"
    >
      <div className="container-app mx-auto flex flex-col items-center justify-center gap-6 px-4 text-center sm:flex-row sm:gap-8">
        <p className="text-base font-medium text-gray-700 md:text-lg">
          Sie haben Fragen oder möchten mit uns zusammenarbeiten? Wir beraten Sie gern.
        </p>
        <button
          type="button"
          onClick={() => openContactModal?.()}
          className="group btn btn-outline shrink-0"
        >
          Jetzt Kontakt aufnehmen
          <ArrowRight className="h-5 w-6 shrink-0 transition-transform duration-200 ease-out group-hover:translate-x-0.5" aria-hidden />
        </button>
      </div>
    </section>
  );
}
